function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withModifiers } from '../../decorators';
import Icon from '../icon';

var SearchBarInput = function SearchBarInput(_ref) {
  var asModal = _ref.asModal,
      children = _ref.children,
      className = _ref.className,
      isExpanded = _ref.isExpanded,
      _onChange = _ref.onChange,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      placeholder = _ref.placeholder,
      tabIndex = _ref.tabIndex,
      others = _objectWithoutProperties(_ref, ["asModal", "children", "className", "isExpanded", "onChange", "onClose", "onSubmit", "placeholder", "tabIndex"]);

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  if (asModal || isExpanded) {
    return React.createElement("div", {
      className: "search-bar"
    }, React.createElement("div", {
      className: "field"
    }, React.createElement("div", {
      className: classNames('control has-icons-left', {
        'active': value.length
      })
    }, React.createElement("input", _extends({
      className: classNames('input', className)
    }, {
      tabIndex: tabIndex,
      placeholder: placeholder
    }, others, {
      onChange: function onChange(e) {
        setValue(e.target.value);
        _onChange && _onChange(e);
      }
    })), children, React.createElement("a", {
      onClick: function onClick(e) {
        return onSubmit && onSubmit(e);
      }
    }, React.createElement(Icon, {
      name: "ui-search"
    })))), React.createElement("a", {
      onClick: function onClick(e) {
        // this.setState({ isExpanded: !isExpanded })
        onClose && onClose(e);
      }
    }, React.createElement(Icon, {
      name: "ui-times",
      "is-large": true
    })));
  } // render inline


  return React.createElement("div", {
    className: "search-bar"
  }, React.createElement("div", {
    className: classNames('control has-icons-right', {
      'active': value.length
    })
  }, React.createElement("input", _extends({
    className: classNames('input', className)
  }, {
    placeholder: placeholder
  }, others, {
    onChange: function onChange(e) {
      setValue(e.target.value);
      _onChange && _onChange(e);
    }
  })), React.createElement("a", {
    onClick: function onClick(e) {
      return onSubmit && onSubmit(e);
    }
  }, React.createElement(Icon, {
    name: "ui-search",
    "is-right": true
  }))));
};

SearchBarInput.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  asModal: PropTypes.bool,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  tabIndex: PropTypes.number,
  isExpanded: PropTypes.bool
};
SearchBarInput.defaultProps = {
  tabIndex: 0
};
SearchBarInput.displayName = 'SearchBar.Input';
export default withModifiers(SearchBarInput);